import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const containerBaseStyles = xcss({
	display: 'inline-flex',
	flexDirection: 'column',
	gap: 'space.075',
	width: '100%',
	marginBottom: 'initial',
	marginTop: 'space.025',
});

export type EditorTitleContainerProps = {
	children: React.ReactNode;
};

// TODO MODES-4246 Remove data-test-id attribute once locustio-load-tester is updated to use data-testid(testId attribute) instead of data-test-id
export const EditorTitleContainer: React.FC<EditorTitleContainerProps> = ({ children }) => (
	<Box
		testId="editor-title-container"
		data-test-id="editor-title-container"
		id="editor-title-id" // required for useProgressiveHeader
		xcss={[containerBaseStyles]}
	>
		{children}
	</Box>
);
EditorTitleContainer.displayName = 'EditorTitleContainer';
